import { render, staticRenderFns } from "./ActiveProjects.vue?vue&type=template&id=338a4311&"
import script from "./ActiveProjects.vue?vue&type=script&lang=js&"
export * from "./ActiveProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports